/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      { title: "Inicio", url: "/", icon: "HomeIcon", is_bookmarked: false },
      // {
      //   title: "Page 2",
      //   url: "/page2",
      //   icon: "FileIcon",
      //   is_bookmarked: false
      // },
      /*{
        title: "Casos",
        url: "/casos",
        icon: "FileTextIcon",
        is_bookmarked: false
      },*/
      // {
      //   title: "Indicadores",
      //   url: "/indicadores",
      //   icon: "BarChart2Icon",
      //   is_bookmarked: false
      // }
    ]
  }
};
/* eslint-enable */
